<template>
  <v-app style="background-color: white;">
    <div style="margin-top:120px" class="bckdiv">
      <p
        class="txt_my"
        style="text-align:center;text-transform: uppercase;color:#FFFFFF;font-weight:bold;margin-top: 50px;"
      >
        T r a v e l &nbsp;&nbsp;a n d &nbsp;&nbsp;e a t &nbsp;&nbsp;l i k e &nbsp;&nbsp;a
        &nbsp;&nbsp;l o c a l
      </p>
      <h1 class="txt_my" style="text-align:center;margin-top:-15px;color:#FFFFFF;">
        Our Services
      </h1>
    </div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm12 md4 style="padding: 10px;">
          <v-card style="background-color: #FAF8ED;" class="mx-auto" max-width="344">
            <v-img
              height="200px"
              src="https://app.majumderspecial.in/flight_rail.jpg"
              cover
            ></v-img>

            <v-card-title style="font-size: large;margin-top: 15px;">
              Flight & Rail e-ticket
            </v-card-title>

            <v-card-actions style="text-align: center;margin-top: -70px;">
              <v-spacer></v-spacer>
              <span
                @click="onContact"
                class="txt_my"
                style="padding: 10px;height: 70px;width: 70px;border-radius: 50%;background-color: #F66F4D;font-weight: 500;color: white;cursor: pointer;"
                >Contact Now</span
              >
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md4 style="padding: 10px;">
          <v-card style="background-color: #FAF8ED;" class="mx-auto" max-width="344">
            <v-img
              height="200px"
              src="https://majumderspecial.in/resorts.jpg"
              cover
            ></v-img>

            <v-card-title style="font-size: large;margin-top: 15px;">
                Hotes & Resorts Booking
            </v-card-title>

            <v-card-actions style="text-align: center;margin-top: -70px;">
              <v-spacer></v-spacer>
              <span
                @click="onContact"
                class="txt_my"
                style="padding: 10px;height: 70px;width: 70px;border-radius: 50%;background-color: #F66F4D;font-weight: 500;color: white;cursor: pointer;"
                >Contact Now</span
              >
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md4 style="padding: 10px;">
          <v-card style="background-color: #FAF8ED;" class="mx-auto" max-width="344">
            <v-img
              height="200px"
              src="https://majumderspecial.in/taxi.jpg"
              cover
            ></v-img>

            <v-card-title style="font-size: large;margin-top: 15px;">
                Cars Booking
            </v-card-title>

            <v-card-actions style="text-align: center;margin-top: -70px;">
              <v-spacer></v-spacer>
              <span
                @click="onContact"
                class="txt_my"
                style="padding: 10px;height: 70px;width: 70px;border-radius: 50%;background-color: #F66F4D;font-weight: 500;color: white;cursor: pointer;"
                >Contact Now</span
              >
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md4 style="padding: 10px;">
          <v-card style="background-color: #FAF8ED;" class="mx-auto" max-width="344">
            <v-img
              height="200px"
              src="https://majumderspecial.in/money.webp"
              cover
            ></v-img>

            <v-card-title style="font-size: large;margin-top: 15px;">
                Money Exchange
            </v-card-title>

            <v-card-actions style="text-align: center;margin-top: -70px;">
              <v-spacer></v-spacer>
              <span
                @click="onContact"
                class="txt_my"
                style="padding: 10px;height: 70px;width: 70px;border-radius: 50%;background-color: #F66F4D;font-weight: 500;color: white;cursor: pointer;"
                >Contact Now</span
              >
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md4 style="padding: 10px;">
          <v-card style="background-color: #FAF8ED;" class="mx-auto" max-width="344">
            <v-img
              height="200px"
              src="https://majumderspecial.in/passport.webp"
              cover
            ></v-img>

            <v-card-title style="font-size: large;margin-top: 15px;">
              Passport & Visa Service
            </v-card-title>

            <v-card-actions style="text-align: center;margin-top: -70px;">
              <v-spacer></v-spacer>
              <span
                @click="onContact"
                class="txt_my"
                style="padding: 10px;height: 70px;width: 70px;border-radius: 50%;background-color: #F66F4D;font-weight: 500;color: white;cursor: pointer;"
                >Contact Now</span
              >
            </v-card-actions>
          </v-card>
        </v-flex>

        <!-- <v-flex xs12 sm12 md4 style="padding: 10px;">
          <v-card style="background-color: #FAF8ED;" class="mx-auto" max-width="344">
            <v-img
              height="200px"
              src="https://majumderspecial.in/group.jpg"
              cover
            ></v-img>

            <v-card-title style="font-size: large;margin-top: 15px;">
                Group Tour
            </v-card-title>

            <v-card-actions style="text-align: center;margin-top: -70px;">
              <v-spacer></v-spacer>
              <span
                @click="onContact"
                class="txt_my"
                style="padding: 10px;height: 70px;width: 70px;border-radius: 50%;background-color: #F66F4D;font-weight: 500;color: white;cursor: pointer;"
                >Contact Now</span
              >
            </v-card-actions>
          </v-card>
        </v-flex> -->

      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      show: false,

      internationalList: [
        {
          title: "Foreast Cocktail Tour",
          name: "Foreast Cocktail Tour",
          subTitle: "Ac cars & Ac hotels pickup drop",
          time: "6 Days, 7 Nights",
          price: "71,000",
          rate: "71,000",
          src:
            "https://t4.ftcdn.net/jpg/02/94/27/73/360_F_294277354_ev3qw00wjlHAfhqRdEozsrVRpbhixC3S.jpg"
        },
        {
          title: "Bangkok - Pattya Tour",
          name: "Bangkok - Pattya Tour",
          time: "5 Days, 4 Nights",
          subTitle: "Ac cars & Ac hotels pickup drop",
          price: "35,500",
          rate: "35,500",
          src:
            "https://i0.wp.com/travelgangtok.com/blog/wp-content/uploads/2023/12/Bangkok-Thailand.jpg?resize=741%2C437&ssl=1"
        },
        {
          title: "Nepal Tour",
          name: "Nepal Tour",
          time: "11 Days, 10 Nights",
          subTitle: "Ac cars & Ac hotels pickup drop",
          price: "18,800",
          rate: "18,800",
          src:
            "https://c4.wallpaperflare.com/wallpaper/873/774/324/nepal-himalayas-ghandruk-mountains-wallpaper-preview.jpg"
        },
        {
          title: "Bhutan Tour",
          name: "Bhutan Tour",
          time: "9 Days, 8 Nights",
          subTitle: "Ac cars & Ac hotels pickup drop",
          price: "17,500",
          rate: "17,500",
          src:
            "https://t3.ftcdn.net/jpg/01/79/70/56/360_F_179705627_8Njoqi3oOOBdJRsafwouCNDV9hdjWn9U.jpg"
        },
        {
          title: "Bangladesh Tour",
          name: "Bangladesh Tour",
          time: "10 Days, 9 Nights",
          subTitle: "Ac cars & Ac hotels pickup drop",
          price: "25,700",
          rate: "25,700",
          src: "https://masterbundles.com/wp-content/uploads/2023/05/11-780.jpg"
        },
        {
          title: "Dubai",
          name: "Dubai",
          time: "10 Days, 9 Nights",
          subTitle: "Ac cars & Ac hotels pickup drop",
          price: "55,600",
          rate: "55,600",
          src: "https://media.tacdn.com/media/attractions-splice-spp-674x446/0a/76/5d/92.jpg"
        }
      ]
    };
  },

  methods: {
    view(des) {
      sessionStorage.setItem("Detail", JSON.stringify(des));
      this.$router.push("/packageDetails/1"); // + des.id
    },
    getData() {
      /* this.axios
          .get(config.API + "Destinations1", {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(res => {
            this.destionation = res.data.domestic;
            this.$Progress.finish();
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.$Progress.fail();
          }); */
    },
    despkg(des) {
      this.$router.push("/destinationPackage/" + des.id);
    },
    onContact() {
      this.$router.push("/ContactUs");
    }
  },

  mounted() {
    this.getData();
    this.$Progress.start();
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap");
@import url("https://fonts.googleapis.com/css?family=Anton&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Alice&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Josefin+Slab:ital,wght@0,100..700;1,100..700&display=swap");
</style>
<style lang="css" scoped>
.tourtheme {
  height: 180px;
  border-radius: 0px;
  margin: 5px;
  background-size: cover;
}
.bckdiv {
    background-image: url("../../assets/aboutus.jpg");
    height: 300px;
    background-size: cover;
}
.hvr:hover {
  cursor: pointer;
  height: 200px;
  /* border : 3px solid; */
  /* border-color: black; */
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.bckclr {
  -webkit-text-fill-color:cornflowerblue
}
.txt_dec:hover {
    text-decoration: none !important;
}
.domImg {
  padding: 5px;
  display: block;
  margin: auto;
  border-radius: 10px;
  height: 180px;
  width: 100%;
}

.domTitle {
  font-family: "Alice", serif !important;
  text-align: left !important;
  font-size: 16px;
  font-weight: 500;
  padding: 5px;
}

.txt_my {
  font-family: "Alice", serif !important;
}
</style>
